import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import PermisoFormSections from "./PermisoFormSections.js";

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
    }

    render() {
        return (
            <ParadigmaModal
                postUrl={api.usuarios.permisos.create}
                onSubmit={() => this.props.onSubmit()}
                successMessage={"El Permiso ha sido creado con éxito."}
                title={"Nuevo Permiso"}
                buttonIcon={"fa fa-plus fa-lg"}
                
                saveButton={true}
                closeButton={true}
                className={"ui-modal-dialog ui-modal-md"}>
                <div className="ui-form">
                    <PermisoFormSections autoFocusFirstField={true} />
                </div>
            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Permisos/Create.js